import {Router, Routes} from '@angular/router';
import {LoginComponent} from "./pages/login/login.component";
import {ProjectsComponent} from "./pages/projects/projects.component";
import {LayoutComponent} from "./components/ui/layout/layout.component";
import {ProjectDetailComponent} from "./pages/project-detail/project-detail.component";
import {ProjectDetailInfoComponent} from "./pages/project-detail-info/project-detail-info.component";
import {
  ProjectDetailPointCloudsComponent
} from "./pages/project-detail-point-clouds/project-detail-point-clouds.component";
import {PointCloudDetailComponent} from "./pages/point-cloud-detail/point-cloud-detail.component";
import {PointCloudDetailInfoComponent} from "./pages/point-cloud-detail-info/point-cloud-detail-info.component";
import {PointCloudDetailViewerComponent} from "./pages/point-cloud-detail-viewer/point-cloud-detail-viewer.component";
import {ProjectsListComponent} from "./pages/projects-list/projects-list.component";
import {ProjectsMapComponent} from "./pages/projects-map/projects-map.component";
import {RedirectComponent} from "./pages/redirect/redirect.component";
import {projectResolver} from "./resolvers/project.resolver";
import {pointCloudResolver} from "./resolvers/point-cloud.resolver";
import {ProjectDetailPhotosComponent} from "./pages/project-detail-photos/project-detail-photos.component";
import {ProjectDetailMapComponent} from "./pages/project-detail-map/project-detail-map.component";
import {TagsComponent} from "./pages/tags/tags.component";
import {TagDetailComponent} from "./pages/tag-detail/tag-detail.component";
import {TagsListComponent} from "./pages/tags-list/tags-list.component";
import {tagResolver} from "./resolvers/tag.resolver";
import {TagDetailInfoComponent} from "./pages/tag-detail-info/tag-detail-info.component";
import {AuthenticationGuard} from "./guards/authentication.guard";
import {AdminGuard} from "./guards/admin.guard";
import {UnmatchedPointCloudsComponent} from "./pages/unmatched-point-clouds/unmatched-point-clouds.component";

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'redirect', component: RedirectComponent},
  {path: 'login', component: LoginComponent},
  {
    path: 'panel', component: LayoutComponent, canActivate: [AuthenticationGuard], children: [
      {path: '', redirectTo: 'projects', pathMatch: 'full'},
      {
        path: 'projects', component: ProjectsComponent, children: [
          {path: '', redirectTo: 'map', pathMatch: 'full'},
          {path: 'map', component: ProjectsMapComponent},
          {path: 'list', component: ProjectsListComponent},
        ]
      },
      {
        path: 'projects/detail/:project', component: ProjectDetailComponent, resolve: { project: projectResolver }, children: [
          {path: '', redirectTo: 'map', pathMatch: 'full'},
          {path: 'map', component: ProjectDetailMapComponent},
          {path: 'info', component: ProjectDetailInfoComponent},
          {path: 'point-clouds', component: ProjectDetailPointCloudsComponent},
          {path: 'photos', component: ProjectDetailPhotosComponent},
        ]
      },
      {
        path: 'projects/:project/point-clouds/detail/:pointCloud', component: PointCloudDetailComponent, resolve: { project: projectResolver, pointCloud: pointCloudResolver }, children: [
          {path: '', redirectTo: 'info', pathMatch: 'full'},
          {path: 'info', component: PointCloudDetailInfoComponent},
          {path: 'viewer', component: PointCloudDetailViewerComponent},
        ]
      },
      {
        path: 'projects/:project/point-clouds/detail/standalone/:pointCloud', component: PointCloudDetailComponent, resolve: { project: projectResolver, pointCloud: pointCloudResolver }, data: { standalone: true }, children: [
          {path: '', redirectTo: 'viewer', pathMatch: 'full'},
          {path: 'info', component: PointCloudDetailInfoComponent},
          {path: 'viewer', component: PointCloudDetailViewerComponent},
        ]
      },
      {
        path: 'tags', component: TagsComponent, children: [
          {path: '', redirectTo: 'list', pathMatch: 'full'},
          {path: 'list', component: TagsListComponent},
        ]
      },
      {
        path: 'tags/detail/:tag', component: TagDetailComponent, resolve: { tag: tagResolver }, children: [
          {path: '', redirectTo: 'info', pathMatch: 'full'},
          {path: 'info', component: TagDetailInfoComponent},
        ]
      },
      {
        path: 'point-clouds/unmatched', 
        component: UnmatchedPointCloudsComponent, 
        canActivate: [AdminGuard]
      },
      {
        path: 'point-clouds/unmatched/detail/:pointCloud', 
        component: PointCloudDetailComponent, 
        resolve: { pointCloud: pointCloudResolver }, 
        data: { standalone: true },
        canActivate: [AdminGuard],
        children: [
          {path: '', redirectTo: 'info', pathMatch: 'full'},
          {path: 'info', component: PointCloudDetailInfoComponent},
          {path: 'viewer', component: PointCloudDetailViewerComponent},
        ]
      },
    ]
  },
];
